import { seriesEsp, seriesEng, seriesId, unitsEsp, unitsEng, groupsEsp, groupsEng } from './translations/translations_frp_espanya_preindustrial.js'
import { translateSeries } from '../lib/translate_series_name.js'

export default class Visualizer {
  series = [];
  charts = [];

  RANGES_DEFAULT = [];
  CHARTS_DEFAULT = [];

  constructor(params) {
    this.charts = params || [];
    this.setDefaults();

    return {
      charts: this.charts.map(x => Object.assign(this.CHARTS_DEFAULT.find(y => y.type == x.type), x)),
      ranges: this.RANGES_DEFAULT,
      endpoints: {
        series: this.series,
        data: {
          build: () => {
            const sql = 'select * from espana_preindustrial ORDER BY year';
            const gobiertoPath = process.env.GOBIERTO_DATA_URL
            const token = process.env.GOBIERTO_DATA_TOKEN
            const query = `?sql=${sql}&token=${token}`;

            return `${gobiertoPath}/api/v1/data/data.json${query}`;
          },
          parse: data => {
            this.series = translateSeries(this.series, seriesEsp, seriesEng, seriesId, unitsEsp, unitsEng, groupsEsp, groupsEng)
            const series = this.series.map(d => ({
              id: d.id,
              name: d.name,
              units: d.units
            }));

            // reorder the return data to be grouped by kind of serie
            const groupBySerie = series.map(set => {
              return data.data.map(d => ({
                serie: set.id,
                time: new Date(d["year"], 0, 1),
                value: parseFloat(d[set.id]),
                name: set.name,
                units: set.units,
                idTooltip: "ep"
              }))
            });

            // give a flatted array
            return groupBySerie.flat();
          }
        }
      }
    };
  }

  setDefaults = () => {
    this.series = [
      {
        "id": "c0_producto_real_agrario",
        "name": "Producto Real Agrario",
        "units": "(1850/9=100)",
        "group": "PIB, población y PIB por habitante, 1277-1850"
      },
      {
        "id": "c0_poblacion_urbana",
        "name": "Población Urbana",
        "units": "(1850/9=100)",
        "group": "PIB, población y PIB por habitante, 1277-1850"
      },
      {
        "id": "c0_producto_real_total",
        "name": "Producto Real Total",
        "units": "(1850/9=100)",
        "group": "PIB, población y PIB por habitante, 1277-1850"
      },
      {
        "id": "c0_poblacion",
        "name": "Población",
        "units": "millones",
        "group": "PIB, población y PIB por habitante, 1277-1850"
      },
      {
        "id": "c0_producto_real_per_capita",
        "name": "Producto Real per Capita",
        "units": "(1850/9=100)",
        "group": "PIB, población y PIB por habitante, 1277-1850"
      },
      {
        "id": "c0_pibpm_nominal",
        "name": "PIBpm Nominal",
        "units": "millones (Reales)",
        "group": "PIB, población y PIB por habitante, 1277-1850"
      },
      {
        "id": "c0_pibpm_nominal_per_capita",
        "name": "PIBpm Nominal Per Capita",
        "units": "actuales (Reales)",
        "group": "PIB, población y PIB por habitante, 1277-1850"
      },
      {
        "id": "c1_indice_de_williamson_nominal",
        "name": "Índice de Williamson (Nominal)",
        "units": "1790/99=100",
        "group": "Distribución de la renta: Índice de Williamson* y Ratio Renta de la tierra/salario, 1277-1850"
      },
      {
        "id": "c1_ratio_renta_de_la_tierra_salario_nominal",
        "name": "Ratio Renta de la tierra/Salario (Nominal)",
        "units": "1790/99=100",
        "group": "Distribución de la renta: Índice de Williamson* y Ratio Renta de la tierra/salario, 1277-1850"
      },
      {
        "id": "c2_espana",
        "name": "España",
        "units": "dólares Geary-Khamis de 1990",
        "group": "Producto Interior Bruto Real per capita en perspectiva europea, 1277-1850 (dólares Geary-Khamis de 1990; nivel de 1990, Maddison Project v. 2013)"
      },
      {
        "id": "c2_francia",
        "name": "Francia",
        "units": "dólares Geary-Khamis de 1990",
        "group": "Producto Interior Bruto Real per capita en perspectiva europea, 1277-1850 (dólares Geary-Khamis de 1990; nivel de 1990, Maddison Project v. 2013)"
      },
      {
        "id": "c2_reino_unido",
        "name": "Reino Unido",
        "units": "dólares Geary-Khamis de 1990",
        "group": "Producto Interior Bruto Real per capita en perspectiva europea, 1277-1850 (dólares Geary-Khamis de 1990; nivel de 1990, Maddison Project v. 2013)"
      },
      {
        "id": "c2_paises_bajos",
        "name": "Países Bajos",
        "units": "dólares Geary-Khamis de 1990",
        "group": "Producto Interior Bruto Real per capita en perspectiva europea, 1277-1850 (dólares Geary-Khamis de 1990; nivel de 1990, Maddison Project v. 2013)"
      },
      {
        "id": "c2_suecia",
        "name": "Suecia",
        "units": "dólares Geary-Khamis de 1990",
        "group": "Producto Interior Bruto Real per capita en perspectiva europea, 1277-1850 (dólares Geary-Khamis de 1990; nivel de 1990, Maddison Project v. 2013)"
      }
    ];

    const range = (start, stop, step = 1) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
    this.RANGES_DEFAULT = range(1277, 1850);

    this.CHARTS_DEFAULT = [{
        type: "Line",
        btnPlaceholder: "Añadir serie",
        xAxisProp: "time",
        yAxisProp: "value",
        aggregationProp: "serie",
        tooltip: this.tooltipCommon,
        bspline: false,
        language: 'es',
        cache: true,
        ticksXAxis: 30,
        tickFormatY: (...args) => {
          const [d, , , d3] = args;

          return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
        }
      },
      {
        type: "Stacked",
        btnPlaceholder: "Añadir serie",
        xAxisProp: "time",
        yAxisProp: "value",
        aggregationProp: "serie",
        tooltip: this.tooltipCommon,
        language: 'es',
        cache: true,
        ticksXAxis: 30,
        tickFormatY: (...args) => {
          const [d, , , d3] = args;

          return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
        }
      }
    ];
  };
  getScale(key, d3) {
    const scales = {
      linear: d3.scaleLinear(),
      log: d3.scaleLog(),
      natural: d3.scaleLog().base(Math.E),
      pow: d3.scalePow()
    };


    if (scales.hasOwnProperty(key)) {
      return scales[key];
    } else {
      return scales[0];
    }
  }
}
